var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.32 49.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.05,21.3v6.03c-.06.06-.12.11-.18.16-2.03,1.58-4.37,2.83-6.88,3.69-1.59.56-3.26.96-4.99,1.19-1.25.18-2.52.27-3.82.27-1.37,0-2.73-.1-4.04-.3-1.66-.23-3.26-.62-4.79-1.15-2.6-.89-4.97-2.18-7.04-3.83v-6.02l13.5,5.53c1.31.55,3.37.55,4.68,0l13.55-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.44,13.23l-4.23,1.73v5.77c.81.35,1.36,1.14,1.36,2.07,0,.84-.46,1.58-1.14,1.95l.57,1.57,1.7,4.73-3.17.84-3.06-.66,1.41-4.82.47-1.58c-.77-.35-1.3-1.13-1.3-2.04s.55-1.72,1.36-2.07v-5.04l-21.14,8.67c-1.17.48-3.05.48-4.22,0L.88,13.23c-1.17-.48-1.17-1.25,0-1.72L28.05.35c1.17-.47,3.05-.47,4.22,0l27.18,11.15c1.17.47,1.17,1.24,0,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4,33.59c-2.94-.36-5.73-1.19-8.26-2.41h-1.24l-3.81,18.32h5.93l.62-2.83h3.28l.59,2.83h6.19l-3.3-15.91Zm-6.31,9.27l1.14-6.14h.12l1.13,6.14h-2.39Zm5.81-11.68h-4.55c1.53.53,3.13.92,4.79,1.15l-.24-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.25,31.18h-1.06c-2.6,1.26-5.46,2.09-8.46,2.45l-3.3,15.87h5.93l.62-2.83h3.28l.59,2.83h6.19l-3.8-18.32Zm-5.81,11.68l1.14-6.14h.12l1.13,6.14h-2.39Zm-3.19-11.68l-.24,1.19c1.72-.23,3.4-.63,4.99-1.19h-4.74Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaIcon);
export default __webpack_public_path__ + "static/media/AA_icon.0f0adab98451144ce4c058bb2b8461e1.svg";
export { ForwardRef as ReactComponent };